import { useState, type FormEvent } from 'react'
import { api, ApiFehler } from '../lib/api'
import { Fenster } from './Fenster'

export function PasswortAendern({ offen, aufSchliessen }: { offen: boolean; aufSchliessen: () => void }) {
  const [altes, setzeAltes] = useState('')
  const [neues, setzeNeues] = useState('')
  const [wiederholung, setzeWiederholung] = useState('')
  const [fehler, setzeFehler] = useState<string | null>(null)
  const [fertig, setzeFertig] = useState<string | null>(null)
  const [laeuft, setzeLaeuft] = useState(false)

  function schliessen() {
    setzeAltes('')
    setzeNeues('')
    setzeWiederholung('')
    setzeFehler(null)
    setzeFertig(null)
    aufSchliessen()
  }

  async function absenden(ereignis: FormEvent) {
    ereignis.preventDefault()
    setzeFehler(null)

    if (neues !== wiederholung) {
      setzeFehler('Die beiden neuen Passwörter sind nicht gleich.')
      return
    }
    if (neues.length < 12) {
      setzeFehler('Das neue Passwort muss mindestens 12 Zeichen haben.')
      return
    }

    setzeLaeuft(true)
    try {
      const antwort = await api.senden<{ andereSitzungenBeendet: number }>('/api/passwort', {
        altesPasswort: altes,
        neuesPasswort: neues,
      })
      setzeFertig(
        antwort.andereSitzungenBeendet > 0
          ? `Passwort geändert. ${antwort.andereSitzungenBeendet} andere Anmeldung wurde beendet.`
          : 'Passwort geändert.',
      )
      setzeAltes('')
      setzeNeues('')
      setzeWiederholung('')
    } catch (problem) {
      setzeFehler(problem instanceof ApiFehler ? problem.message : 'Das Passwort konnte nicht geändert werden.')
    } finally {
      setzeLaeuft(false)
    }
  }

  return (
    <Fenster titel="Passwort ändern" offen={offen} aufSchliessen={schliessen}>
      <form className="formular" onSubmit={(e) => void absenden(e)}>
        {fehler && <div className="fehler">{fehler}</div>}
        {fertig && <div className="bestaetigung">{fertig}</div>}

        <div>
          <label htmlFor="p-alt">Bisheriges Passwort</label>
          <input
            id="p-alt"
            type="password"
            autoComplete="current-password"
            required
            value={altes}
            onChange={(e) => setzeAltes(e.target.value)}
          />
        </div>

        <div>
          <label htmlFor="p-neu">Neues Passwort</label>
          <input
            id="p-neu"
            type="password"
            autoComplete="new-password"
            required
            value={neues}
            onChange={(e) => setzeNeues(e.target.value)}
          />
          <div className="hinweis">Mindestens 12 Zeichen. Länge hilft mehr als Sonderzeichen.</div>
        </div>

        <div>
          <label htmlFor="p-neu2">Neues Passwort wiederholen</label>
          <input
            id="p-neu2"
            type="password"
            autoComplete="new-password"
            required
            value={wiederholung}
            onChange={(e) => setzeWiederholung(e.target.value)}
          />
        </div>

        <div className="formular-fuss">
          <button type="button" className="knopf still" onClick={schliessen}>
            {fertig ? 'Schließen' : 'Abbrechen'}
          </button>
          <button type="submit" className="knopf gefuellt" disabled={laeuft}>
            {laeuft ? 'Wird geändert …' : 'Ändern'}
          </button>
        </div>
      </form>
    </Fenster>
  )
}
